var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, indent, no-unused-vars, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp, space-unary-ops */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

/* globals $_, i18n */
var InfoTip = require("../components/info-tip.jsx");
var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");

var ApiOptions = require("../perseus-api.jsx").Options;
var assert = require("../interactive2/interactive-util.js").assert;

var Graphie = require("../components/graphie.jsx");
var Path = Graphie.Path,
    Arc = Graphie.Arc,
    Circle = Graphie.Circle,
    Label = Graphie.Label,
    Line = Graphie.Line,
    MovablePoint = Graphie.MovablePoint,
    MovableLine = Graphie.MovableLine;

var NumberInput = require("../components/number-input.jsx");
var MathOutput = require("../components/math-output.jsx");
var seededRNG = require("../util.js").seededRNG;
var Util = require("../util.js");
var knumber = require("kmath").number;
var KhanColors = require("../util/colors.js");
var KhanMath = require("../util/math.js");

var defaultBoxSize = 400;
var maxSampleSize = 1000;
var maxTrials = 5000;

var Histogram = React.createClass({
    displayName: "Histogram",

    propTypes: {
        data: React.PropTypes.arrayOf(React.PropTypes.number),
        xAxisLabel: React.PropTypes.string,
        yAxisLabel: React.PropTypes.string,
        box: React.PropTypes.arrayOf(React.PropTypes.number)
    },

    getDefaultProps: function getDefaultProps() {
        return {
            data: null,
            xAxisLabel: "Proportion (%)",
            yAxisLabel: "Number of times seen",
            box: [defaultBoxSize, defaultBoxSize]
        };
    },

    getInitialState: function getInitialState() {
        return {
            threshold: this._getInitialThreshold(this._range())
        };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        // Reset the threshold if the range has changed
        var oldRange = this._range();
        var nextRange = this._range(nextProps);
        if (!Util.deepEq(oldRange, nextRange)) {
            this.setState({
                threshold: this._getInitialThreshold(nextRange)
            });
        }
    },

    /* Renders the vertical line that users can drag across the histogram. */
    _renderThresholdLine: function _renderThresholdLine() {
        var _this = this;

        // Recall the the y-range goes from [-1, yMax] to allow for ticks on
        // the x-axis.
        var yRange = [0, this._range()[1][1]];
        var coords = _.map(yRange, function (y) {
            return [_this.state.threshold, y];
        });

        // Returns an inivisble, placeholder coord that anchors the line
        var invisiblePointForCoord = function invisiblePointForCoord(coord, i) {
            return React.createElement(MovablePoint, {
                key: i,
                "static": true,
                coord: coord,
                normalStyle: { stroke: "none", fill: "none" }
            });
        };

        return React.createElement(
            MovableLine,
            { onMove: this.handleMouseInteraction },
            _.map(coords, invisiblePointForCoord)
        );
    },

    /* Renders the shaded circle in the top right. */
    _renderCircle: function _renderCircle() {
        var _this2 = this;

        var data = this.props.data;

        // Get proportion of results below threshold
        var total = _.reduce(data, function (sum, next) {
            return sum + next;
        }, 0);
        var numBelow = _.reduce(data, function (sum, next, i) {
            if (_this2.state.threshold != null && i <= _this2.state.threshold) {
                return sum + next;
            } else {
                return sum;
            }
        }, 0);
        var proportionBelow = numBelow / total;

        // This is a hack around the arc taking angles modulo 360.
        // TODO(charlie): Find a better way around this.
        var epsilon = 1e-5;
        var radius = 20;
        var center = [this.props.box[0] - 1.5 * radius, 1.5 * radius];

        // Plot little circle
        var plotBelowCircle = function plotBelowCircle() {
            var options = {
                key: "below",
                center: center,
                radius: radius,
                startAngle: 0,
                endAngle: proportionBelow < 1 ? 360 * proportionBelow : 360 - epsilon,
                sector: proportionBelow !== 1,
                unscaled: true,
                style: {
                    fill: KhanColors.LIGHT_RED,
                    stroke: KhanColors.RED
                }
            };

            return React.createElement(Arc, options);
        };
        var plotAboveCircle = function plotAboveCircle() {
            var options = {
                key: "above",
                center: center,
                radius: radius,
                startAngle: proportionBelow > 0 ? 360 * proportionBelow : epsilon,
                endAngle: 360,
                sector: proportionBelow !== 0,
                unscaled: true,
                style: {
                    fill: KhanColors.LIGHT_BLUE,
                    stroke: KhanColors.BLUE
                }
            };

            return React.createElement(Arc, options);
        };

        // Plot the label below the circle
        var xRange = this._range()[0];
        var formattedThreshold = Math.min(Math.max(this.state.threshold, xRange[0]), xRange[1]).toFixed(2);
        var plotLabel = function plotLabel() {
            var options = {
                key: "label",
                coord: [center[0], center[1] + 1.5 * radius],
                text: numBelow + " of " + total + " results below " + formattedThreshold + "%",
                direction: "center",
                tex: false,
                unscaled: true,
                style: {
                    fontSize: "12px"
                }
            };
            return React.createElement(Label, options);
        };

        return [proportionBelow > 0 && plotBelowCircle(), proportionBelow < 1 && plotAboveCircle(), plotLabel()];
    },

    /* Renders the actual bars of the histogram. */
    _renderData: function _renderData() {
        var _this3 = this;

        var data = this.props.data;
        var range = this._range();

        // Plot bars
        var barWidth = 1;
        var pathForData = function pathForData(count, i) {
            // Avoid plotting bars of height 0, else you get a thick blue line
            // over the x-axis. We don't filter these out of the data passed in
            // to this function, however, to preserve absolute indices.
            if (!count) {
                return;
            }

            var isBelow = _this3.state.threshold != null && i <= _this3.state.threshold;
            var style = {
                fill: isBelow ? KhanColors.LIGHT_RED : KhanColors.LIGHT_BLUE,
                stroke: isBelow ? KhanColors.RED : KhanColors.BLUE
            };
            var coords = [[i, 0], [i, count], [i + barWidth, count], [i + barWidth, 0]];
            return React.createElement(Path, { key: i, coords: coords, style: style });
        };

        return _.map(data, pathForData);
    },

    render: function render() {
        var data = this.props.data;
        var range = this._range();

        var options = {
            xAxisLabel: this.props.xAxisLabel,
            yAxisLabel: this.props.yAxisLabel,
            box: this.props.box,
            range: range,
            data: data,
            scale: [Util.scaleFromExtent(range[0], this.props.box[0]), Util.scaleFromExtent(range[1], this.props.box[1])]
        };

        var axisStyle = {
            stroke: "#000",
            strokeWidth: 1,
            opacity: 1.0
        };
        var origin = [range[0][0], 0];
        var bottomRight = [range[0][1], 0];

        return React.createElement(
            Graphie,
            {
                box: options.box,
                range: options.range,
                options: options,
                setup: this._setupGraphie,
                onMouseMove: this.handleMouseInteraction,
                onMouseDown: this.handleMouseInteraction,
                setDrawingAreaAvailable: this.props.setDrawingAreaAvailable
            },
            React.createElement(Line, { start: origin, end: bottomRight, style: axisStyle }),
            data && this._renderData(),
            data && this._renderCircle(),
            data && this._renderThresholdLine()
        );
    },

    _setupGraphie: function _setupGraphie(graphie, options) {
        var data = options.data;
        var range = options.range;
        var scale = options.scale;

        /* Plot the bars that run parallel to the x-axis. */
        var xWidth = range[0][1] - range[0][0];
        var yWidth = range[1][1] - 0;

        var maxYAxisEntities = 20;
        var ySkip = Math.ceil(yWidth / maxYAxisEntities);
        _.each(_.range(0, range[1][1], ySkip), function (y) {
            // If there's no data, we don't label the axes
            if (data) {
                graphie.label([range[0][0], y], KhanMath.roundToApprox(y, 2), "left",
                /* isTeX */true /* for the \approx symbol */
                );
            }

            graphie.line([range[0][0], y], [range[0][1], y], {
                stroke: "#000",
                strokeWidth: 1,
                opacity: 0.3
            });
        });

        // If there's no data, we don't label the x-axis at all
        if (data) {
            // Plot the labels below the bars
            var maxXAxisEntities = 15;
            var xSkip = Math.ceil(xWidth / maxXAxisEntities);
            _.each(_.range(range[0][0], range[0][1], xSkip), function (x) {
                graphie.label([x, 0], knumber.round(x, 2), "below", true);

                var tickHeight = 8;
                graphie.line([x, 0], [x, -tickHeight / scale[1]], {
                    stroke: "#000",
                    strokeWidth: 1
                });
            });
        }

        // Add y axis (x axis is added later to overlap the bars)
        var axisStyle = {
            stroke: "#000",
            strokeWidth: 2,
            opacity: 1.0
        };
        var origin = [range[0][0], 0];
        var topLeft = [range[0][0], range[1][1]];
        graphie.line(origin, topLeft, axisStyle);

        // Add axis labels
        var xMid = range[0][0] + xWidth / 2;
        var xOffset = data ? 25 : 0;
        graphie.label([xMid, -xOffset / scale[1]], options.xAxisLabel, "below", false).css("font-weight", "bold");

        var yMid = 0 + yWidth / 2;
        var yOffset = data ? 55 : 28;
        graphie.label([range[0][0] - yOffset / scale[0], yMid], options.yAxisLabel, "center", false).css("font-weight", "bold").css("-webkit-transform", "rotate(-90deg)");
    },

    handleMouseInteraction: function handleMouseInteraction(point) {
        this.setState({
            threshold: point[0]
        });
    },

    /* Convenience functions that help calculate props based on other props. */
    _range: function _range(props) {
        var defaultRange = [[0, 100], [-1, 10]];
        props = props || this.props;
        return props.data ? this._getRangeForData(props.data) : defaultRange;
    },

    _getRangeForData: function _getRangeForData(data) {
        // Find first/last non-zero entry and add some padding
        var padding = 10;
        var firstIndex = _.indexOf(data, _.find(data, function (n) {
            return n > 0;
        }));
        var xMin = Math.max(0, firstIndex - padding);
        var lastIndex = _.lastIndexOf(data, _.last(_.filter(data, function (n) {
            return n > 0;
        })));
        var xMax = Math.min(100 + 1, lastIndex + 1 + padding);

        // The y-axis is bounded above by largest value, and below by 0.
        // However, the 'range' of the y-axis goes as low as -1 to allow
        // Graphie to draw ticks on the x-Axis that extend vertically below
        // y = 0.
        var yMin = -1;
        var yMax = _.max(data);

        return [[xMin, xMax], [yMin, yMax]];
    },

    _getInitialThreshold: function _getInitialThreshold(range) {
        // We pick a pretty-looking threshold, 1/3 of the way along the axis
        var xRange = range[0];
        return xRange[0] + (xRange[1] - xRange[0]) / 3;
    }
});

var Simulator = React.createClass({
    displayName: "Simulator",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,
        data: React.PropTypes.arrayOf(React.PropTypes.number),
        numTrials: React.PropTypes.number,
        proportionLabel: React.PropTypes.string,
        proportionOrPercentage: React.PropTypes.string,
        randomSeed: React.PropTypes.number,
        sampleSize: React.PropTypes.number,
        trackInteraction: React.PropTypes.func.isRequired,
        userProportion: React.PropTypes.number,
        xAxisLabel: React.PropTypes.string,
        yAxisLabel: React.PropTypes.string
    }),

    getInitialState: function getInitialState() {
        return {
            invalidInput: false
        };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            data: null,
            userProportion: null,
            sampleSize: null,
            numTrials: null,
            randomSeed: 0,
            xAxisLabel: "Proportion (%)",
            yAxisLabel: "Number of times seen",
            proportionLabel: "Underlying proportion",
            proportionOrPercentage: "proportion",
            apiOptions: ApiOptions.defaults
        };
    },

    componentWillMount: function componentWillMount() {
        if (this.props.randomSeed != null) {
            this.generateNumber = Util.seededRNG(this.props.randomSeed);
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (nextProps.randomSeed !== this.props.randomSeed) {
            this.generateNumber = Util.seededRNG(nextProps.randomSeed);
        }
    },

    render: function render() {
        var _this4 = this;

        var inputStyle = {
            marginLeft: "5px"
        };

        var highlight = "0px 0px 0px 2px rgba(255, 165, 0, 1)";
        var highlightStyle = _.extend({}, inputStyle, {
            WebkitBoxShadow: highlight,
            MozBoxShadow: highlight,
            boxShadow: highlight,
            transition: "all 0.15s"
        });
        var unhighlightStyle = _.extend({}, inputStyle, {
            transition: "all 0.15s"
        });
        var style = this.state.invalidInput ? highlightStyle : unhighlightStyle;

        var InputComponent = this.props.apiOptions.staticRender ? MathOutput : NumberInput;

        var proportionInput = React.createElement(
            "div",
            null,
            React.createElement(InputComponent, {
                ref: "userProportion",
                style: style,
                value: this.calculateDisplayProportion(),
                checkValidity: this.checkProportionValidity,
                disabled: this.props.apiOptions.readOnly,
                onChange: this.handleUserProportionChange,
                onFocus: function onFocus() {
                    return _this4.props.onFocus(["userProportion"]);
                },
                onBlur: function onBlur() {
                    return _this4.props.onBlur(["userProportion"]);
                }
            }),
            React.createElement(
                InfoTip,
                null,
                React.createElement(
                    "p",
                    null,
                    "This controls the proportion or percentage that will be used in your simulation."
                )
            )
        );

        var sampleSizeInput = React.createElement(
            "div",
            null,
            React.createElement(InputComponent, {
                ref: "sampleSize",
                style: style,
                value: this.props.sampleSize,
                checkValidity: function checkValidity(val) {
                    return val >= 0;
                },
                disabled: this.props.apiOptions.readOnly,
                onChange: this.handleSampleSizeChange,
                onFocus: function onFocus() {
                    return _this4.props.onFocus(["sampleSize"]);
                },
                onBlur: function onBlur() {
                    return _this4.props.onBlur(["sampleSize"]);
                }
            }),
            React.createElement(
                InfoTip,
                null,
                React.createElement(
                    "p",
                    null,
                    "This controls the sample size that will be used in your simulation. For example, if you set this to 100, then for each trial, responses from 100 participants will be simulated."
                )
            )
        );

        var numTrialsDisplay = React.createElement(
            "div",
            { style: { textAlign: "right" } },
            React.createElement(
                "b",
                null,
                this.props.numTrials
            ),
            React.createElement(
                InfoTip,
                null,
                React.createElement(
                    "p",
                    null,
                    "This is the number of trials used in the simulation. For example, if set to 50, then the survey will be conducted 50 times."
                )
            )
        );

        // Generates a table from a set of titles and values.
        var generateTable = function generateTable(contents) {
            var header = React.createElement(
                "thead",
                null,
                React.createElement(
                    "tr",
                    null,
                    React.createElement(
                        "th",
                        null,
                        "Parameter"
                    ),
                    React.createElement(
                        "th",
                        null,
                        "Value"
                    )
                )
            );

            var body = React.createElement(
                "tbody",
                null,
                _.map(contents, function (row, i) {
                    return React.createElement(
                        "tr",
                        { key: i },
                        React.createElement(
                            "td",
                            null,
                            row.title
                        ),
                        React.createElement(
                            "td",
                            null,
                            row.value
                        )
                    );
                })
            );

            return React.createElement(
                "table",
                null,
                header,
                body
            );
        };

        // Contents for the table to-be generated
        var contents = [{
            title: this.props.proportionLabel + ":",
            value: proportionInput
        }, {
            title: "Sample size:",
            value: sampleSizeInput
        }, {
            title: "Number of trials:",
            value: numTrialsDisplay
        }];

        // The 'Run Simulation' button
        var buttonStyle = {
            margin: "20px 0"
        };
        var startButton = React.createElement(
            "button",
            {
                className: "simple-button",
                style: buttonStyle,
                disabled: this.props.apiOptions.readOnly,
                onClick: this.handleRunSimulation
            },
            i18n._("Run simulation")
        );

        // When we plot data, ticks on the x-axis require some vertical padding
        var histogramStyle = {
            paddingBottom: this.props.data ? 40 : 0
        };
        var histogram = React.createElement(
            "div",
            { style: histogramStyle },
            React.createElement(Histogram, {
                data: this.props.data,
                xAxisLabel: this.props.xAxisLabel,
                yAxisLabel: this.props.yAxisLabel,
                setDrawingAreaAvailable: this.props.apiOptions.setDrawingAreaAvailable
            })
        );

        return React.createElement(
            "div",
            null,
            generateTable(contents),
            startButton,
            histogram
        );
    },

    calculateDisplayProportion: function calculateDisplayProportion() {
        var userProportion = this.props.userProportion;

        // If we want to display as a percentage, multiply proportion by 100.0.
        if (this.props.proportionOrPercentage === "percentage") {
            return Math.round(100 * userProportion);
        } else {
            return userProportion;
        }
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    checkProportionValidity: function checkProportionValidity(value) {
        return value >= 0.0 && this.props.proportionOrPercentage === "proportion" && value <= 1.0 || this.props.proportionOrPercentage === "percentage" && value <= 100.0;
    },

    handleUserProportionChange: function handleUserProportionChange(value, cb) {
        var userProportion;

        // If "percentage" mode is enabled, user will have entered value as
        // a percentage. However, we always store as a proportion, so we cast.
        if (this.props.proportionOrPercentage === "percentage") {
            userProportion = value / 100.0;
        } else {
            userProportion = value;
        }

        // If they entered a number, we may need to cap it
        if (userProportion != null) {
            userProportion = Math.min(1.0, Math.max(0.0, userProportion));
        }
        this.props.onChange({
            userProportion: userProportion
        }, cb);
    },

    handleSampleSizeChange: function handleSampleSizeChange(sampleSize, cb) {
        if (sampleSize != null) {
            sampleSize = Math.min(maxSampleSize, Math.max(0, Math.floor(sampleSize)));
        }
        this.props.onChange({
            sampleSize: sampleSize
        }, cb);
    },

    handleRunSimulation: function handleRunSimulation() {
        // If they haven't filled out a parameter field, highlight it.
        if (this.props.numTrials == null || this.props.userProportion == null || this.props.sampleSize == null) {
            this.setState({
                invalidInput: true
            });
            return;
        } else {
            this.setState({
                invalidInput: false
            });
        }
        this.props.onChange({
            data: this.generateData()
        });
        this.props.trackInteraction();
    },

    generateData: function generateData(props) {
        var _this5 = this;

        props = props || this.props;
        var getSampleDistribution = function getSampleDistribution(sampleSize, numTrials, proportion) {
            var draw = function draw() {
                return _this5.generateNumber() < proportion;
            };
            var sampleDistribution = _.times(100 + 1, function () {
                return 0;
            });
            _.times(numTrials, function () {
                var results = _.times(sampleSize, draw);
                var count = _.filter(results, _.identity).length;
                var normalizedCount = Math.floor(100 * count / sampleSize);
                sampleDistribution[normalizedCount]++;
            });
            return sampleDistribution;
        };
        return getSampleDistribution(props.sampleSize, props.numTrials, props.userProportion);
    },

    /* InputPath API */
    getInputPaths: function getInputPaths() {
        return [["userProportion"], ["sampleSize"]];
    },

    focus: function focus() {
        var path = _.head(this.getInputPaths());
        this.focusInputPath(path);
        return true;
    },

    focusInputPath: function focusInputPath(path) {
        assert(path.length > 0);
        var inputID = _.head(path);
        var inputComponent = this.refs[inputID];
        inputComponent.focus();
    },

    blurInputPath: function blurInputPath(path) {
        assert(path.length > 0);
        var inputID = _.head(path);
        var inputComponent = this.refs[inputID];
        inputComponent.blur();
    },

    getDOMNodeForPath: function getDOMNodeForPath(path) {
        assert(path.length > 0);
        var inputID = _.head(path);
        return ReactDOM.findDOMNode(this.refs[inputID]);
    },

    getGrammarTypeForPath: function getGrammarTypeForPath(path) {
        assert(path.length > 0);
        return "number";
    },

    setInputValue: function setInputValue(path, newValue, cb) {
        assert(path.length > 0);
        var inputID = _.head(path);
        var capitalizedID = inputID.charAt(0).toUpperCase() + inputID.slice(1);
        var functionName = "handle" + capitalizedID + "Change";
        this[functionName](newValue, cb);
    },

    getUserInput: function getUserInput() {
        return null;
    },

    simpleValidate: function simpleValidate(rubric) {
        return Simulator.validate(this.getUserInput(), rubric);
    }
});

_.extend(Simulator, {
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    }
});

var propTransform = function propTransform(editorProps) {
    var widgetProps = _.clone(editorProps);
    widgetProps.randomSeed = editorProps.problemNum;
    return widgetProps;
};

module.exports = {
    name: "simulator",
    displayName: "Simulator",
    widget: Simulator,
    transform: propTransform,
    hidden: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/simulator.jsx
 ** module id = 146
 ** module chunks = 0 1
 **/